import {
  FocusEventHandler,
  KeyboardEventHandler,
  useRef,
  useState,
} from 'react';

export type UseTimeInputProps = {
  onCancel?: () => void;
  onApply: (value: string) => void;
  defaultValue: string;
};
//identical to useSeparateInput, except onChange formatting, onApply trimming, defaultValue
export const useTimeInput = (allProps: UseTimeInputProps) => {
  const { defaultValue, onCancel, ...props } = allProps;

  const [stateValue, setStateValue] = useState(defaultValue);

  const escaping = useRef(false);

  const onKeyDown: KeyboardEventHandler<HTMLInputElement> = (evt) => {
    switch (evt.key) {
      case 'Enter':
        evt.currentTarget.blur();
        return;
      case 'Escape':
        setStateValue(defaultValue);
        //after setValue, onBlur will not call props.onApply because values are equal
        if (onCancel) {
          onCancel();
        }
        escaping.current = true;
        evt.currentTarget.blur();
        return;
    }
  };

  const formatTime = (value: string): string => {
    let bluredValue = value;
    const rawValueArray = value.split(':');
    let hours = '';
    let minutes = '';
    if (rawValueArray.length == 2) {
      hours = rawValueArray[0];
      minutes = rawValueArray[1];
    } else {
      hours = bluredValue;
    }

    if (rawValueArray.length == 1 && minutes == '') {
      bluredValue = hours + ':00';
    } else {
      if (minutes == '') {
        bluredValue += '00';
      } else if (minutes.length == 1 && parseInt(minutes) < 6) {
        bluredValue += '0';
      } else if (minutes.length == 1 && parseInt(minutes) >= 6) {
        bluredValue = hours + ':59';
      } else if (hours.length == 2 && minutes == '') {
        bluredValue = hours + '00';
      }
    }

    return bluredValue;
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //seems AI-generated, don't try to understand and edit
    let rawValue =
      e.target.value.indexOf(':') !== e.target.value.lastIndexOf(':')
        ? e.target.value.slice(0, e.target.value.lastIndexOf(':'))
        : e.target.value;

    if (/[^0-9:]/.test(rawValue)) {
      return;
    }
    const rawValueArray = rawValue.split(':');
    let hours = '';
    let minutes = '';
    if (rawValueArray.length == 2) {
      hours = rawValueArray[0];
      minutes = rawValueArray[1];
    }

    if (rawValueArray.length == 1 && minutes == '') {
      if (rawValue.length == 2 && rawValue.startsWith('0')) {
        rawValue = rawValue.slice(0, 2) + ':';
      } else if (rawValue.length == 1 && parseInt(rawValue) >= 3) {
        rawValue = rawValue + ':';
      } else if (
        rawValue.length == 2 &&
        parseInt(rawValue.charAt(0)) == 2 &&
        parseInt(rawValue.charAt(1)) >= 4
      ) {
        rawValue = '23:';
      } else if (
        rawValue.length == 2 &&
        parseInt(rawValue.charAt(0)) == 2 &&
        parseInt(rawValue.charAt(1)) < 4
      ) {
        rawValue += ':';
      } else if (rawValue.length == 2 && parseInt(rawValue.charAt(0)) == 1) {
        rawValue = rawValue + ':';
      }
    } else {
      if (minutes.length == 3) {
        rawValue = hours + ':' + minutes.charAt(0) + minutes.charAt(2);
        // } else if (parseInt(minutes) > 59) {
        //     rawValue = hours + ':59';
      } else if (minutes.length == 1 && parseInt(minutes) >= 6) {
        rawValue = hours + ':0' + minutes;
      }
    }

    setStateValue(rawValue);
  };

  const onBlur: FocusEventHandler<HTMLInputElement> = () => {
    if (escaping.current) {
      escaping.current = false;
      return;
    }

    const formatted = formatTime(stateValue);
    setStateValue(formatted);

    if (formatted !== defaultValue) {
      props.onApply(formatted);
    }
  };

  // const handleBackspace = () => {
  //   const updatedValue = localValue.slice(0, -1);
  //   setLocalValue(updatedValue);
  // };

  // const onKeyDown: KeyboardEventHandler<HTMLInputElement> = (e) => {
  //   if (e.key === 'Backspace') handleBackspace();
  // };

  return {
    type: 'text',
    value: stateValue,
    onChange,
    onBlur,
    onKeyDown,
    pattern: '([01]?[0-9]{1}|2[0-3]{1}):[0-5]{1}[0-9]{1}',
  };
};
